@if (required) {
  <div class="weaveFormField"
    [ngClass]="{'error': ctrl.invalid && (ctrl.dirty || ctrl.touched)}"
    >
    @if (label && longTitle) {
      <div class="pageHeader" id="fakeLabel1">
        {{label}}<span class="required">*</span>
      </div>
    }
    <mat-form-field appearance="outline" class="fullWidth">
      @if (label && !longTitle) {
        <mat-label>{{label}}</mat-label>
      }
      <textarea
        matInput
        cdkTextareaAutosize #autosize="cdkTextareaAutosize"
        [disabled]="disabledFlag"
        [placeholder]="placeholder"
        [maxlength]="maxlength"
        [rows]="rows"
        [(ngModel)]='data'
        (blur)="onFocusOut()"
        (keyup)="onKeyUp()"
        (focusin)="startEdit()"
        (keydown.escape)="undo()"
        required
        #ctrl="ngModel"
        aria-labelledby="fakeLabel1"
      ></textarea>
      @if(description) {
        <mat-hint align="start">
          {{description}}
        </mat-hint>
      }
      <mat-error *ngIf="ctrl.invalid && ctrl.touched">
        {{label || "This field"}} cannot be empty
      </mat-error>
    </mat-form-field>
  </div>
}
@if (!required) {
  <div class="weaveFormField">
    @if (label && longTitle) {
      <div class="pageHeader" id="fakeLabel">
        {{label}}
      </div>
    }
    <mat-form-field appearance="outline" class="fullWidth">
      @if (label && !longTitle) {
        <mat-label>{{label}}</mat-label>
      }
      <textarea
        matInput
        cdkTextareaAutosize #autosize="cdkTextareaAutosize"
        [disabled]="disabledFlag"
        [placeholder]="placeholder"
        [maxlength]="maxlength"
        [rows]="rows"
        [(ngModel)]='data'
        (blur)="onFocusOut()"
        (keyup)="onKeyUp()"
        (focusin)="startEdit()"
        (keydown.escape)="undo()"
        aria-labelledby="fakeLabel"
      ></textarea>
      @if(description) {
      <mat-hint align="start">
        {{description}}
      </mat-hint>
      }

    </mat-form-field>
  </div>
}
